import React from "react";
import Image from "next/image";

const ExportMoney = ({ data }) => {
  if (!data) return null;

  return (
    <section className="bg-[#FFFFFF] py-sp-100 sm:py-20">
      <div className="container px-6 sm:px-3">
          <h2 className="text-darkBlack text-heading2 sm:text-2xl font-medium mb-3 text-center">
            {data.heading}
          </h2>
          <p className="text-darkBlack text-lg sm:text-base text-center">
            {data.subHeading}
          </p>
        <div className="flex sm:flex-col gap-8 w-full justify-between mt-6">
          {data.cards.map((card) => (
            <div
              key={card.id}
              className="flex-1 bg-white p-3 rounded-2xl border border-borderColor flex flex-col justify-between"
            >
              <div>
                <Image src={card.icon} width={48} height={48} alt={card.title}/>
                <h3 className="text-brand text-base2 font-medium my-2">
                  {card.title}
                </h3>
                <p className="text-[#072F5F] text-sm">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#072F5F] text-white rounded-xl p-10 sm:p-4 mt-20 sm:mt-12 flex sm:flex-col items-center gap-5">
          <div className="flex flex-col items-center shrink-0 w-[300px] sm:w-full">
            <span className="text-[#E3A003] text-[100px] sm:text-headingbig font-medium">
              {data.opportunity.percentage}
            </span>
            <span className="text-lg text-center text-white">
              {data.opportunity.subventionText}
            </span>
          </div>

          <div className="hidden sm:block w-full h-[1px] bg-white" />
          <div className="block sm:hidden w-[1px] h-32 self-stretch bg-white m-auto" />

          <div className="flex-1">
            <h3 className="text-white text-xxl sm:text-lg font-medium mb-2">
              {data.opportunity.title}
            </h3>
            <p className="text-white text-base2 sm:text-sm">
              {data.opportunity.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExportMoney;
